<template>
  <button
    type="button"
    class="brand-header-logo"
    :aria-label="$t('branding.appName')"
    @click="$emit('click')"
  >
    <!-- The official Gabber logo (Ben 2026-10-01): public/logo.svg in its own #C4AAE7 in
         both themes, never recoloured by a theme token. -->
    <img class="logo-image" src="/logo.svg" :alt="$t('branding.appName')" />
  </button>
</template>

<script setup lang="ts">
// Gabber Logo Component
interface Props {
  size?: string | number;
  aspectRatio?: number; // Width to height ratio (e.g., 2.5 for rectangular logo)
}

// size / aspectRatio stay on the API for existing callers; the wordmark keeps the
// SVG's own aspect ratio and the 100px cap it always rendered at.
withDefaults(defineProps<Props>(), {
  size: '60px',
  aspectRatio: 1.41
});

defineEmits<{
  click: [];
}>();
</script>

<style scoped>
.brand-header-logo {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  transition: opacity 0.2s ease;
  display: inline-block;
  border-radius: 8px;
  overflow: hidden;
}

.brand-header-logo:focus-visible {
  outline: 2px solid var(--g-focus-ring);
  outline-offset: 2px;
}

.logo-image {
  display: block;
  width: 100px;
  max-width: 100px;
  height: auto;
  aspect-ratio: 506 / 172;
  object-fit: contain;
}

.logo-placeholder {
  background: transparent;
}
</style>
